<template>
  <div class="px-4 py-5 space-y-4">
    <div>
      <h1 class="text-lg font-extrabold text-slate-800 text-left">My Applications</h1>
      <p class="text-xs text-slate-500 text-left">Track every job you applied for</p>
    </div>

    <LoadingState
      :loading="loading"
      :message="!loading && !applications.length ? 'You have not applied to any jobs yet.' : ''"
    />

    <button
      v-for="app in applications"
      :key="app.id"
      type="button"
      class="card-panel w-full p-4 text-left hover:bg-slate-50/80 transition"
      @click="$router.push({ name: 'application_detail', params: { id: app.id } })"
    >
      <div class="flex items-start justify-between gap-3">
        <div class="min-w-0">
          <h2 class="text-sm font-bold text-slate-800 truncate">{{ getJobEntryTitle({ title: app.job_title }, app.job_entry_index) }}</h2>
          <p class="text-xs text-slate-500 mt-1">{{ formatAppMeta(app) }}</p>
        </div>
        <StatusBadge :status="app.status" />
      </div>
    </button>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { apiFetch } from '../utils/api'
import { getJobEntryTitle, splitJobValues } from '../utils/jobFields'
import LoadingState from '../components/LoadingState.vue'
import StatusBadge from '../components/StatusBadge.vue'

export default {
  name: 'MyApplicationsView',
  components: { LoadingState, StatusBadge },
  setup() {
    const applications = ref([])
    const loading = ref(true)

    function formatAppMeta(app) {
      const idx = Number(app.job_entry_index) || 0
      const sectors = splitJobValues(app.job_sector).filter(Boolean)
      const salaries = splitJobValues(app.job_salary).filter(Boolean)
      const sector = sectors[idx] || sectors[0] || '—'
      const salary = salaries[idx] || salaries[0] || 'Salary N/A'
      return `${sector} · ${salary}`
    }

    async function load() {
      loading.value = true
      try {
        const res = await apiFetch('/applications/mine')
        const data = await res.json()
        applications.value = data.applications || []
      } catch (err) {
        console.error(err)
      } finally {
        loading.value = false
      }
    }

    onMounted(load)
    return { applications, loading, getJobEntryTitle, formatAppMeta }
  },
}
</script>
